import styled from 'styled-components'
import { ButtonMui } from 'src/components/ButtonMui'

export const Container = styled.div`
  display: flex;
  width: '100%';
  gap: 1rem;
`
export const ContainerDescription = styled.div`
  display: flex;
  flex-direction: column;

  p {
    font-size: 16px;
  }
`

export const ContainerItems = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: .6rem;
  gap: .8rem;
`

export const ContainerCharacteristicsFooter = styled.span`
  display: inline-flex;
  justify-content: space-between;
  margin: 1.3rem .4rem .4rem .4rem !important;
  gap: .3rem;
`

export const TotalSelectedQuantityInfo = styled.span`
  align-self: center;
`

export const CustomButton = styled(ButtonMui)`
  align-self: center;
  width: 12rem;
  height: 2.5rem !important;
`

export const Item = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: .2rem;
`
